export default "__VITE_ASSET__c7bed8e8__"